import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { filter, firstValueFrom } from 'rxjs';
import Swal from 'sweetalert2';
import { AuthenticationContants } from 'src/app/constants/authentication-constants';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { OptionWindow } from 'src/app/enum/option-window-enums';
import { ProfileUserEnums } from 'src/app/enum/profile-user-enums';
import { WindowEnums } from 'src/app/enum/window-enums';
import { TableAction } from 'src/app/interfaces/custom-table/custom-table-action.interface';
import { OptionWindowModel } from 'src/app/models/authentication/option-window.model';
import { UserModel } from 'src/app/models/authentication/user.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { StockMaxMinTableModel } from 'src/app/models/tables/inventory/stock-max-min-table-model';
import { OptionWindowService } from 'src/app/services/authentication/option-window.service';
import { WindowService } from 'src/app/services/authentication/window.service';
import { UserAuthenticatedService } from 'src/app/services/global-services/user-authenticated.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { StockMaxMinService } from 'src/app/services/inventory/stock-max-min.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import { BranchService } from 'src/app/services/management/branch.service';
import { InventoryService } from 'src/app/services/inventory/inventory.service';
import { CustomModalComponent } from 'src/app/components/custom-modal/custom-modal.component';
import { ImportStockMaxMinComponent } from '../import-stock-max-min/import-stock-max-min.component';

@Component({
  selector: 'app-stock-max-min',
  templateUrl: './stock-max-min.component.html',
  styleUrls: ['./stock-max-min.component.scss'],
  standalone: false
})
export class StockMaxMinComponent implements OnInit {

  @ViewChild('stockMaxMinImportModal') stockMaxMinImportModal?: CustomModalComponent | null = null;
  ascendant: boolean = true;
  branchId: number = 0;
  columnSort: string | null = null;
  componentStockMaxMinImportModal = ImportStockMaxMinComponent;
  filters: ColumnResponseModel[] = [];
  data: PagedResponseModel<StockMaxMinTableModel> = new PagedResponseModel<StockMaxMinTableModel>();
  generalHeader: ColumnResponseModel[] = [];
  inventoryId: number = 0;
  isOpened: string | undefined = undefined;
  limit: number = 10;
  nameWindow: string = 'Topes Máximos-Mínimos';
  page: number = 1;
  permissionUpdatable: boolean = false;
  permissionsUser: Array<OptionWindowModel> = new Array<OptionWindowModel>();
  projectName = ProjectName.projectName;
  tableActions: TableAction[] = [
    { action: 'edit', icon: 'pi pi-pencil', label: 'Editar' },
    { action: 'delete', icon: 'pi pi-trash', label: 'Eliminar' }
  ];
  url: string = '';
  userAuthenticated: UserModel = new UserModel();

  constructor(
    private branchService: BranchService,
    private headerService: HeaderService,
    private inventoryService: InventoryService,
    private optionWindowService: OptionWindowService,
    private router: Router,
    private stockMaxMinService: StockMaxMinService,
    private title: Title,
    private toastHandlerService: ToastHandlerService,
    private userAuthenticatedService: UserAuthenticatedService,
    private windowService: WindowService
  ) { }

  async ngOnInit() {
    this.headerService.setTitle(this.nameWindow);
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    const filters = localStorage.getItem('stock-max-min');
    if (filters) this.filters = JSON.parse(filters);
    this.getPermission();
    await Promise.all([
      this.getFirstInventoryByCompanyAuthenticated(),
      this.getFirstBranchByUserAuthenticated(),
      this.getColumnsForGeneralConsultation()
    ])
    this.setInitialFilters();
    this.getStockMaxMinWithPagination()
  }

  @HostListener('window:beforeunload')
  beforeUnloadHandler() {
    this.ngOnDestroy();
  }

  async ngOnDestroy() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      const window = windowsOpened.findIndex(x => x === this.url);
      if (window != -1) {
        windowsOpened.splice(window, 1);
        localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      }
    }
  }

  async deleteStockMaxMin(stockMaxMin: StockMaxMinTableModel) {
    if (this.permissionUpdatable) {
      const result = await Swal.fire({
        title: 'Atención',
        text: `¿Realmente desea eliminar el Tope Máximo-Mínimo?`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si',
        cancelButtonText: 'No'
      });
      if (result.isConfirmed) {
        try {
          await firstValueFrom(this.stockMaxMinService.deleteStockMaxMin(stockMaxMin.stockMaxMinId));
          this.toastHandlerService.showToast('success',
            'El Tope Máximo-Mínimo fue eliminado exitosamente.'
          );
          this.getStockMaxMinWithPagination();
        } catch (error) {
          console.error('Error al eliminar el Tope Máximo-Mínimo.', error);
        }
      }
    } else {
      this.toastHandlerService.showToast('error',
        'El usuario no tiene permisos para Topes Máximos-Mínimos. Comuníquese con el administrador del sistema.'
      );
    }
  }

  async exportGeneralConsultation() {
    if (
      this.userAuthenticated.profileUser.code == ProfileUserEnums.administrador ||
      this.permissionsUser.find(x => x.code == OptionWindow.Exportar)
    ) {
      try {
        const response = await firstValueFrom(
          this.stockMaxMinService.exportGeneralConsultation(
            this.filters,
            this.columnSort,
            this.ascendant
          )
        );
        const blob = response;
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'TopesMaximosMinimos.xlsx';
        a.click();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error('Error al exportar Topes Máximos-Mínimos.', error);
      }
    } else {
      this.toastHandlerService.showToast('warning',
        'El usuario no tiene permisos para exportar Topes Máximos-Mínimos mínimos, comuniquese con el administrador del sistema.'
      );
    }
  }

  async getColumnsForGeneralConsultation() {
    try {
      if (this.generalHeader.length === 0) {
        this.generalHeader = await firstValueFrom(
          this.stockMaxMinService.getColumnsForGeneralConsultation()
        );
      }
    } catch (error) {
      console.error('Error al buscar las columnas para la consulta general.', error);
    }
  }

  async getFirstBranchByUserAuthenticated() {
    try {
      const response = await firstValueFrom(this.branchService.getFirstBranchByUserAuthenticatedAsync());
      this.branchId = response.branchId;
    } catch (error) {
      console.error('Error al obtener la sucursal.', error);
    }
  }

  async getFirstInventoryByCompanyAuthenticated() {
    try {
      const response = await firstValueFrom(this.inventoryService.getFirstInventoryByCompanyAuthenticatedAsync());
      this.inventoryId = response.inventoryId;
    } catch (error) {
      console.error('Error al obtener inventario principal de la compañia.', error);
    }
  }

  async getPermission() {
    let url = this.router.url as string;
    url = url.substring(1);
    this.url = url;

    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);

    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      this.isOpened = windowsOpened.find(x => x === this.url);
      windowsOpened.push(this.url);
      localStorage.setItem(
        AuthenticationContants.keyWindowsOpenedLocalStorage,
        JSON.stringify(windowsOpened)
      );

      if (this.isOpened) {
        this.toastHandlerService.showToast(
          'error',
          `No se permite tener dos ventanas/pestañas de ${this.nameWindow} abiertas.`
        );
      }
    } else {
      localStorage.clear();
    }

    try {
      this.permissionUpdatable = await firstValueFrom(
        this.windowService.getPermissionProfileByUrl(this.url)
      );
      this.getPermissionsForUserByWindow();
    } catch (error) {
      console.error('Error al buscar los permisos por perfil.', error);
    }
  }

  async getPermissionsForUserByWindow() {
    this.userAuthenticated = await firstValueFrom(
      this.userAuthenticatedService.userObservable.pipe(
        filter(user => user && user.userId !== 0)
      )
    );
    this.permissionsUser = await firstValueFrom(
      this.optionWindowService.getPermissionsForUserByWindow(WindowEnums.StockMaxMin)
    );
  }

  async getStockMaxMinWithPagination() {
    try {
      this.data = await firstValueFrom(
        this.stockMaxMinService.getAllStockMaxMinWithPagination(
          this.page,
          this.limit,
          this.columnSort,
          this.ascendant,
          this.filters
        )
      );
    } catch (error) {
      console.error('Error al buscar los Topes Máximos-Mínimos mínimos.', error);
    }
  }

  newStockMaxMin() {
    if (this.permissionUpdatable) {
      this.router.navigate(['/stock-max-min/register']);
    } else {
      this.toastHandlerService.showToast('error',
        'El usuario no tiene permisos para crear Topes Máximos-Mínimos. Comuníquese con el administrador del sistema.'
      );
    }
  }

  onAction(event: { action: string; item?: StockMaxMinTableModel; selectedItems?: number[] }) {
    if (event.action === 'edit' && event.item) {
      this.router.navigate([`/${this.url}/register/${event.item.id}`]);
    }
    if (event.action === 'delete' && event.item) {
      this.deleteStockMaxMin(event.item);
    }
  }

  async onExport() {
    await this.exportGeneralConsultation();
  }

  async onFilterChange(event: { filters: any }) {
    const filters = event.filters.map((value: any, index: any): any => ({ value, index }))
      .sort((a: any, b: any) => b.index - a.index).map((item: any) => item.value);

    this.filters = this.removeDuplicates(filters);
    this.filters.forEach((filter: any) => this.processFilter(filter));
  }

  async onImport() {
    if (this.userAuthenticated.profileUser.code == ProfileUserEnums.administrador || this.permissionsUser.find(x => x.code == OptionWindow.Importar)) {
      if (this.permissionUpdatable) {
        this.stockMaxMinImportModal && this.stockMaxMinImportModal.show();
      } else {
        this.toastHandlerService.showToast('warning', `El usuario no tiene permisos para la edición de topes maximos-minimos.
          Comuníquese con el administrador del sistema.`);
      }
    } else {
      this.toastHandlerService.showToast('warning', `El usuario no tiene permisos para importar topes maximos-minimos,
        comuniquese con el administrador del sistema.`);
    }
  }

  async onPageChange(event: { page: number; pageSize: number; sortField: string | undefined; sortOrder: number; }) {
    this.page = event.page;
    this.limit = event.pageSize;
    this.columnSort = event.sortField || null;
    this.ascendant = event.sortOrder === 1;
    await this.getStockMaxMinWithPagination();
  }

  processFilter(filter: any): void {
    const { propertyName, valueFilter, valueAlterFilter } = filter;

    if (valueFilter === null || valueFilter === undefined || valueFilter === '' || valueFilter === 0
    ) {
      this.filters = this.filters.filter(f => f.propertyName !== propertyName);
    } else {
      const existingFilter = this.filters.find(f => f.propertyName === propertyName);
      if (existingFilter) {
        existingFilter.valueFilter = valueFilter;
        existingFilter.valueAlterFilter = valueAlterFilter;
      }
    }
  }

  async reloadList(reload: boolean) {
    if (reload) {
      this.setInitialFilters();
      this.getStockMaxMinWithPagination();
    }
  }

  removeDuplicates(filters: any[]): any[] {
    return filters.filter(
      (value, index, self) =>
        index === self.findIndex((t: any) => t.propertyName === value.propertyName)
    );
  }

  setInitialFilters() {
    this.filters = [];

    const inventoryFilter = this.generalHeader.find(x => x.propertyName === 'inventoryCode');
    const branchFilter = this.generalHeader.find(x => x.propertyName === 'branchCode');

    if (inventoryFilter) {
      this.filters.push({
        ...inventoryFilter,
        valueFilter: this.inventoryId.toString(),
        valueAlterFilter: null
      });
    }

    if (branchFilter) {
      this.filters.push({
        ...branchFilter,
        valueFilter: this.branchId.toString(),
        valueAlterFilter: null
      });
    }
  }
}